import { Templates } from '../../compile';
import { ViewOptions } from '../../interfaces/options';

export const DefaultListViewOptions: ViewOptions = {
	template: Templates.list_view
};
